import React, { useEffect, useState } from "react";
import addresicon from "../../assets/images/address-1.svg";
import arrowLeft from "../../assets/images/arrow-leftttttt.svg";
import { useNavigate, useParams } from "react-router-dom";
import { jobService } from "services/job.service";
import { Offcanvas } from "react-bootstrap";
import { getFormattedDate } from "utils";
import BidList from "./BidList";
import { toast } from "react-toastify";
import useCurrentUser from "hooks/useCurrentUser";
import Negotiation from "components/Modals/FormPopup/Negotiation";
import userimg from "../../assets/images/avatar.svg";
import msgActiveimg from "../../assets/images/msg-blue.svg";
import { chatService } from "services/chat.service";

const BidDetailsPage = () => {
  const { id } = useParams()
  const [show, setShow] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [showNegotiate, setShowNegotiate] = useState(false);
  const [data, setData] = useState([])
  const [showVerify, setShowVerify] = useState(false);
  const [bidAmount, setBidAmount] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const navigate = useNavigate();
  const { user } = useCurrentUser();

  const BidDetails = async () => {
    try {
      const response = await jobService.jobBidDetails(id);
      setData(response?.data?.data)
    } catch (err) {
      console.log(err);
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const payload = {
        jobBidId: id,
        bidAmount: bidAmount
      }

      const response = await jobService.negotiateBid(payload);
      setData(response?.data);

      setShowForm(false);
      handleClose();

      toast.success('Bid negotiated successfully', { autoClose: 1000 });
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    BidDetails()
  }, [])
  
  const handleBack = () => {
    navigate(-1);
  }

  const handleNavigate = (data) => {
    if (data?.length > 0) {
      const [lng, lat] = data;
      const googleMapsURL = `https://www.google.com/maps?q=${lat},${lng}`;
      window.open(googleMapsURL, '_blank');
    }
  }

  const onClickSaveJob = () => {
    setShowVerify(true);
  }

  const updateBidStatus = async () => {
    const payload = {
      jobBidId: id,
      status: "Accept"
    }
    try {
      const response = await jobService.updateBidStatus(payload);
      // setActiveTab && setActiveTab("InProgress");
      // setShowBids(false);
      handleClose();
      navigate('/my-bids');
      toast.success('Bid accepted successfully', { autoClose: 1000 });
    } catch (err) {
      console.log(err);
    }
  }
  const getJobAmount = () => {
    if (data?.pilotNegotiatedBidAmount) {
      return data?.pilotNegotiatedBidAmount;
    } else if (data?.clientNegotiatedBidAmount) {
      return data?.clientNegotiatedBidAmount;
    } else if (data?.pilotInitialBidAmount) {
      return data?.pilotInitialBidAmount;
    }
  }

  const job = data?.jobId;

  const showButtons = job?.status === "Pending" && data?.pilotInitialBidAmount && data?.clientNegotiatedBidAmount && !data?.pilotNegotiatedBidAmount;

  const onShowNegotiate = () => {
    setShowNegotiate(true);
  }

  const onChatClick = async (jobId, clientId, pilotId) => {
    try {
      const response = await chatService.startChat({ jobId, clientId, pilotId });
      navigate(`/chat?id=${response?.data?.data?._id}`)
    } catch (err) {
      toast.error(err.data.message);
    }
  }

  return (
    <>
      <div className="container-box">
        <div className="top-head d-flex flex-wrap justify-content-between align-items-center text-white">
          <h2>
            <img src={arrowLeft} className="me-3 cursor-pointer" onClick={handleBack} />Bid Details
          </h2>
        </div>
        <div className="outer-white job-details-page">
          <div className="row">
            <div className="col">
              <div>
                <div className="d-flex align-items-center gap-2 justify-content-between">
                  <div>
                    <img
                      alt="avatar"
                      src={`${user?.baseS3Url}${job?.clientId?.avatar || ""}`}
                      className="round-img border border-secondary"
                      onError={(e) => {
                        e.currentTarget.src = userimg;
                      }}
                    />

                    <p className="mb-0 mt-2 ms-2 dark-textss d-inline">{job?.clientId?.fullName}</p>
                  </div>
                  <img alt="" src={msgActiveimg} className="msg-v cursor-pointer"
                    onClick={() => onChatClick(job?._id, job?.clientId?._id, data?.pilotId?._id)} />
                </div>
                <h3 style={{ marginBottom: 20 }}>{job?.title}</h3>
                {/* <div className="d-flex justify-content-between flex-wrap gap-2"> */}
                {/* <div className="d-flex mt-4 mb-4 align-items-center gap-2">
                  </div> */}
                {/* </div> */}
                <div>
                  <div className="details-para cursor-pointer" onClick={() => handleNavigate(job?.coordinates)}>
                    <h6 className="light-texts">Destination</h6>
                    <p>
                      {job?.address}
                      <img src={addresicon} className="ms-2" />
                    </p>
                  </div>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="row">
                        <div className="col-lg-6">
                          <div>
                            <p className="light-texts">Required Date</p>
                            <p className="dark-textss">{getFormattedDate(job?.requiredDate)}</p>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          {job?.areaSize && <div>
                            <p className="light-texts">{`Area Size (${job?.areaUnit?.toLowerCase()})`}</p>
                            <p className="dark-textss">{job?.areaSize}</p>
                          </div>}

                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mb-4 mt-4">
                  <h6 className="light-texts">Specialized</h6>
                  <div className="d-flex gap-2 flex-wrap">
                    {data?.specialisedId?.map((item, i) => {
                      return <>
                        <span className="blue-bedge">{item?.title}</span>
                      </>
                    })}
                  </div>
                </div>

                <div className="details-para">
                  <h6 className="light-texts">Description</h6>
                  <p>
                    {job?.description}
                  </p>
                </div>

                <div className="details-para">
                  <h6 className="light-texts">Instruction</h6>
                  <p>
                    {job?.instructions}
                  </p>
                </div>


                <div>
                  <div className="amount-div">
                    <h5 className="d-inline">{data?.pilotInitialBidAmount ? 'Bid Amount ($):' : null} </h5>
                    <p className="d-inline">&nbsp; {data?.pilotInitialBidAmount}</p>
                  </div>
                  <br />
                  {data?.clientNegotiatedBidAmount || data?.pilotNegotiatedBidAmount ? <b>
                    Negotiation:
                  </b> : null}
                  {data?.clientNegotiatedBidAmount && (<div className="amount-div">
                    <h5 className="d-inline">User ($):</h5>
                    <p className="d-inline">&nbsp; {data?.clientNegotiatedBidAmount}</p>
                  </div>)}
                  {data?.pilotNegotiatedBidAmount && (<div className="amount-div">
                    <h5 className="d-inline">Pilot ($):</h5>
                    <p className="d-inline">&nbsp; {data?.pilotNegotiatedBidAmount}</p>
                  </div>)}

                  {data?.status && <div className="amount-div">
                    <h5 className="d-inline">Status : </h5>

                    <p className="d-inline ">&nbsp;{data?.status === 'RejectedByClient' ? "Rejected" : data?.status}</p>
                  </div>}

                  <div className="d-flex flex-wrap gap-2 justify-content-between">
                    <div className="d-flex flex-wrap gap-3 amount-div" >
                      {data?.pilotNegotiatedBidAmount && job?.status === "PilotAssigned" ? (
                        <>
                          <h5>Total Approved Amount ($)</h5>
                          <p> &nbsp; {getJobAmount()}</p>
                        </>
                      ) : null}
                    </div>
                    <div className="d-flex flex-wrap gap-3">
                      {showButtons && (
                        <>
                          <button className="blue-btnnn text-dark border-0" onClick={() => onShowNegotiate()} style={{ background: '#e9f0f6', color: '#000' }}>
                            Negotiate
                          </button>
                          <button className="blue-btnnn text-white border-0" onClick={updateBidStatus}>
                            Accept
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="my-4">
            {showForm && (
              <form onSubmit={handleSubmit}>
                <div className="mb-30">
                  <label className="py-2">Enter your negotiate amount ($)</label>
                  <br />
                  <input
                    type="text"

                    onChange={(e) => setBidAmount(e.target.value)}
                    className="form-control rounded-3 bg-cyan w-100"
                    required
                  />
                </div>

                <div className="d-flex flex-wrap justify-content-between">
                  <button type="button"
                    className=" border-0 gray-btn"
                    onClick={() => setShowForm(false)}
                  >
                    Cancel
                  </button>

                  <button type="submit"
                    className=" border-0 blue-btn"
                  >
                    Submit
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
      <Offcanvas
        show={show}
        onHide={handleClose}
        backdrop="static"
        placement="end"
        className="bid-request-modal-client"
      >
        <Offcanvas.Header closeButton></Offcanvas.Header>

        <Offcanvas.Body className="bid-request-modal p-0">
          <BidList id={id} />
        </Offcanvas.Body>
      </Offcanvas>
      <Negotiation
        show={showNegotiate}
        handleClose={() => setShowNegotiate(false)}
        selectedBidId={data?._id}
        bidsData={data}
        setBidsData={setData}
      />
    </>
  );
};

export default BidDetailsPage;